<div class="container-fluid">
    <p-toast [style]="{'marginTop': '80px'}"></p-toast>

    <!-- Header toolbar -->
    <div class="mt-2 d-flex justify-content-between align-items-center flex-wrap gap-2">

        <div>
            <h2 style="margin: 0;">Monthly Statement Expenses</h2>
            <span class="text-muted" style="font-size: 0.85rem;">
                All properties &mdash; view and edit statement expenses for a given month
            </span>
        </div>

        <!-- Month picker + Search -->
        <div [formGroup]="form1" class="d-flex align-items-center gap-2 flex-wrap">
            <div class="p-float-label">
                <p-calendar
                    inputId="monthYear"
                    formControlName="monthYear"
                    [style]="{'width':'180px'}"
                    appendTo="body"
                    view="month"
                    dateFormat="mm/yy"
                    [yearRange]="'2020:2035'"
                    placeholder="Select Month/Year"
                    [showIcon]="true"
                    icon="pi pi-calendar">
                </p-calendar>
                <label for="monthYear">Month / Year</label>
            </div>

            <button pButton class="p-button btn-addt" (click)="formSearch()" [disabled]="loading">
                <i class="pi pi-search" style="margin-right:6px;"></i>Search
            </button>

            <button pButton class="p-button p-button-outlined" (click)="formSearch()" [disabled]="loading">
                <i class="pi pi-refresh" style="margin-right:6px;"></i>Refresh
            </button>
        </div>

        <!-- Right-side toolbar: totals + bulk + export -->
        <div class="d-flex align-items-center gap-2 flex-wrap">

            <span class="badge bg-secondary" style="font-size:0.85rem;">
                {{ expenses.length }} records
            </span>
            <span class="badge bg-primary" style="font-size:0.85rem;">
                KBM: {{ totalKbm | currency:'USD' }}
            </span>
            <span class="badge bg-info text-dark" style="font-size:0.85rem;">
                Owner: {{ totalOwner | currency:'USD' }}
            </span>

            <button
                pButton
                class="p-button p-button-success p-button-sm"
                [disabled]="!selectedExpenses || selectedExpenses.length === 0"
                (click)="bulkSetShowToStmt(true)"
                title="Mark selected as Show on Statement">
                <i class="pi pi-eye" style="margin-right:4px;"></i>Show on Stmt
            </button>

            <button
                pButton
                class="p-button p-button-warning p-button-sm"
                [disabled]="!selectedExpenses || selectedExpenses.length === 0"
                (click)="bulkSetShowToStmt(false)"
                title="Mark selected as Hide from Statement">
                <i class="pi pi-eye-slash" style="margin-right:4px;"></i>Hide from Stmt
            </button>

            <button
                pButton
                class="p-button p-button-secondary p-button-sm"
                (click)="exportCsv()"
                [disabled]="exportLoading || expenses.length === 0">
                <i class="pi pi-download" style="margin-right:4px;"></i>Export CSV
            </button>
        </div>
    </div>

    <!-- Table -->
    <div class="mt-3">
        <p-table
            #dt
            class="kbmadmintable"
            [value]="expenses"
            dataKey="ownerStmtExpId"
            [loading]="loading"
            styleClass="p-datatable-striped p-datatable-sm"
            [style]="{'width':'100%'}"
            [resizableColumns]="true"
            [autoLayout]="true"
            [paginator]="true"
            [rows]="200"
            [rowsPerPageOptions]="[100,200,500,1000]"
            showCurrentPageReport="true"
            currentPageReportTemplate="{totalRecords} records. Page {currentPage} of {totalPages}"
            [globalFilterFields]="['propertyCode','name','description']"
            [editMode]="'row'"
            [(selection)]="selectedExpenses"
            sortField="propertyCode"
            [sortOrder]="1">

            <ng-template pTemplate="header">
                <tr>
                    <th style="width:40px;">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th pSortableColumn="propertyCode" style="min-width:110px;">
                        Property <p-sortIcon field="propertyCode"></p-sortIcon>
                    </th>
                    <th pSortableColumn="stmtStatus" style="min-width:120px;">
                        Stmt Status <p-sortIcon field="stmtStatus"></p-sortIcon>
                    </th>
                    <th pSortableColumn="stmtBilledDate" style="min-width:110px;">
                        Billed Date <p-sortIcon field="stmtBilledDate"></p-sortIcon>
                    </th>
                    <th pSortableColumn="expenseCategory" style="min-width:120px;">
                        Category <p-sortIcon field="expenseCategory"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name" style="min-width:180px;">
                        Description <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="amountPaidByKBM" style="min-width:110px;">
                        KBM Paid <p-sortIcon field="amountPaidByKBM"></p-sortIcon>
                    </th>
                    <th pSortableColumn="amountPaidByOwner" style="min-width:110px;">
                        Owner Paid <p-sortIcon field="amountPaidByOwner"></p-sortIcon>
                    </th>
                    <th pSortableColumn="showToStmt" style="min-width:90px;">
                        On Stmt <p-sortIcon field="showToStmt"></p-sortIcon>
                    </th>
                    <th style="min-width:120px;">Actions</th>
                </tr>

                <!-- Filter row -->
                <tr>
                    <th></th>
                    <th>
                        <p-multiSelect
                            [options]="propertyOptions"
                            appendTo="body"
                            optionLabel="label"
                            optionValue="value"
                            (onChange)="onPropertyFilterChange($event)"
                            placeholder="Filter"
                            [filter]="true"
                            [style]="{'width':'100%'}">
                        </p-multiSelect>
                    </th>
                    <th>
                        <p-dropdown
                            [options]="stmtStatusOptions"
                            appendTo="body"
                            optionLabel="label"
                            optionValue="value"
                            [showClear]="true"
                            placeholder="All"
                            (onChange)="dt.filter($event.value, 'stmtStatus', 'equals')"
                            [style]="{'width':'100%'}">
                        </p-dropdown>
                    </th>
                    <th>
                        <input
                            pInputText
                            type="text"
                            placeholder="Filter"
                            (input)="dt.filter($any($event.target).value, 'stmtBilledDate', 'contains')"
                            [style]="{'width':'100%'}">
                    </th>
                    <th>
                        <p-dropdown
                            [options]="expenseCategoryOptions"
                            appendTo="body"
                            optionLabel="label"
                            optionValue="value"
                            [showClear]="true"
                            placeholder="All"
                            (onChange)="dt.filter($event.value, 'expenseCategory', 'equals')"
                            [style]="{'width':'100%'}">
                        </p-dropdown>
                    </th>
                    <th>
                        <input
                            pInputText
                            type="text"
                            placeholder="Search"
                            (input)="dt.filter($any($event.target).value, 'name', 'contains')"
                            [style]="{'width':'100%'}">
                    </th>
                    <th></th>
                    <th></th>
                    <th>
                        <p-dropdown
                            [options]="showToStmtOptions"
                            appendTo="body"
                            optionLabel="label"
                            optionValue="value"
                            [showClear]="true"
                            placeholder="All"
                            (onChange)="dt.filter($event.value, 'showToStmt', 'equals')"
                            [style]="{'width':'100%'}">
                        </p-dropdown>
                    </th>
                    <th></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-expense let-editing="editing" let-ri="rowIndex">
                <tr [pEditableRow]="expense">
                    <td>
                        <p-tableCheckbox [value]="expense"></p-tableCheckbox>
                    </td>

                    <!-- Property (frozen-style, bold) -->
                    <td>
                        <strong>{{ expense.propertyCode }}</strong>
                    </td>

                    <!-- Stmt status badge -->
                    <td>
                        <span class="p-tag"
                            [ngClass]="{
                                'p-tag-secondary': expense.stmtStatus === 1,
                                'p-tag-danger':    expense.stmtStatus === 2,
                                'p-tag-warning':   expense.stmtStatus === 3 || expense.stmtStatus === 4 || expense.stmtStatus === 5,
                                'p-tag-success':   expense.stmtStatus === 6,
                                'p-tag-info':      expense.stmtStatus === 7
                            }">
                            {{ getStatusLabel(expense.stmtStatus) }}
                        </span>
                    </td>

                    <!-- Billed date (read-only) -->
                    <td>{{ expense.stmtBilledDate | date:'MM/dd/yy' }}</td>

                    <!-- Category (read-only) -->
                    <td>{{ getCategoryLabel(expense.expenseCategory) }}</td>

                    <!-- Description (read-only) -->
                    <td>
                        <span [title]="expense.description">{{ expense.name }}</span>
                    </td>

                    <!-- KBM Paid (editable) -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="number" [(ngModel)]="expense.amountPaidByKBM"
                                    style="width:90px;">
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ expense.amountPaidByKBM | currency:'USD' }}
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <!-- Owner Paid (editable) -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="number" [(ngModel)]="expense.amountPaidByOwner"
                                    style="width:90px;">
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{ expense.amountPaidByOwner | currency:'USD' }}
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <!-- Show to Stmt (editable toggle) -->
                    <td>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-inputSwitch [(ngModel)]="expense.showToStmt"></p-inputSwitch>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <i class="pi"
                                    [ngClass]="expense.showToStmt ? 'pi-check-circle text-success' : 'pi-times-circle text-muted'">
                                </i>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <!-- Actions -->
                    <td>
                        <div class="d-flex gap-1 align-items-center">
                            <ng-container *ngIf="!editing">
                                <button pButton pInitEditableRow type="button"
                                    class="p-button-rounded p-button-text p-button-sm"
                                    icon="pi pi-pencil"
                                    title="Edit"
                                    (click)="onRowEditInit(expense)">
                                </button>
                                <button pButton type="button"
                                    class="p-button-rounded p-button-text p-button-sm p-button-secondary"
                                    icon="pi pi-external-link"
                                    title="Open Statement"
                                    (click)="openStatement(expense.ownerStmtId)">
                                </button>
                            </ng-container>
                            <ng-container *ngIf="editing">
                                <button pButton pSaveEditableRow type="button"
                                    class="p-button-rounded p-button-text p-button-sm p-button-success"
                                    icon="pi pi-check"
                                    title="Save"
                                    (click)="onRowEditSave(expense)">
                                </button>
                                <button pButton pCancelEditableRow type="button"
                                    class="p-button-rounded p-button-text p-button-sm p-button-danger"
                                    icon="pi pi-times"
                                    title="Cancel"
                                    (click)="onRowEditCancel(expense, ri)">
                                </button>
                            </ng-container>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="footer">
                <tr>
                    <td colspan="6" class="text-end fw-bold">Totals:</td>
                    <td class="fw-bold">{{ totalKbm | currency:'USD' }}</td>
                    <td class="fw-bold">{{ totalOwner | currency:'USD' }}</td>
                    <td colspan="2"></td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10" class="text-center p-4 text-muted">
                        <ng-container *ngIf="loading">Loading expenses...</ng-container>
                        <ng-container *ngIf="!loading">No expenses found for the selected month.</ng-container>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
